import { useEffect, useState } from 'react';
import { referralApi, ReferralMe } from '../api/referral';
import { useAppStore } from '../store/useAppStore';
import { Icon } from '../components/Icon';
import { telegram } from '../lib/telegram';

export function ReferralScreen() {
  const setScreen = useAppStore((s) => s.setScreen);
  const showToast = useAppStore((s) => s.showToast);
  const [me, setMe] = useState<ReferralMe | null>(null);

  useEffect(() => {
    referralApi.me().then(setMe).catch(() => undefined);
  }, []);

  const copy = async () => {
    if (!me) return;
    try {
      await navigator.clipboard.writeText(me.link);
      showToast('Ссылка скопирована');
    } catch {
      showToast('Не удалось скопировать', true);
    }
  };

  const share = () => {
    if (!me) return;
    telegram.share('Залетай в 1Zov — провабли-фейр казино на TON. Бонус за вход!', me.link);
  };

  return (
    <>
      <div className="page-head">
        <button className="icon-btn" onClick={() => setScreen('profile')} title="Назад">
          <Icon name="back" size={18} />
        </button>
        <span className="title">Пригласить друзей</span>
      </div>

      <div className="card ref-card">
        <div className="ref-hero">
          <span className="ref-emblem">
            <Icon name="gift" size={26} />
          </span>
          <div className="ref-bonus">+{me?.bonus ?? '250'} обоим</div>
          <p className="muted">Друг заходит по твоей ссылке — вы оба получаете бонус.</p>
        </div>

        <div className="ref-stat">
          <span className="muted">Приглашено друзей</span>
          <b className="tnum">{me?.referrals ?? 0}</b>
        </div>

        <div className="ref-link">{me?.link ?? '…'}</div>

        <button className="btn" onClick={share} disabled={!me}>
          Поделиться ссылкой
        </button>
        <button className="btn ghost" onClick={copy} disabled={!me}>
          <Icon name="copy" size={14} /> Скопировать
        </button>
      </div>
    </>
  );
}
